/*

  u t i l s
  Utils

  :description:
  A file to hold generic utility functions.
  Note, this file should't import other files, only packages.

*/

export const isTruthy = (value, noIsTruthy) => {
  if (typeof value === 'undefined') {
    return false
  }
  if (value === undefined || value === null) {
    return false
  }
  if (value === '') {
    return false
  }
  if (value === 0) {
    return false
  }
  if (value === 0.0) {
    return false
  }
  if (typeof value === 'object') {
    if (Object.keys(value).length === 0) {
      return false
    }
  }
  if (value === false) {
    return false
  }
  if (value === 'false') {
    return false
  }
  if (typeof value === 'string') {
    if (value.length === 0) {
      return false
    }
  }
  if (value === 'no' && !noIsTruthy) {
    return false
  }
  if (value === 'null') {
    return false
  }
  if (value === 'undefined') {
    return false
  }
  if (value === null) {
    return false
  }
  return true
}

export const isDefined = value => {
  return typeof value !== 'undefined'
}

export const since = then => {
  let milliseconds = null
  if (typeof then === 'number') {
    milliseconds = Date.now() - then
  } else {
    milliseconds = new Date().getTime() - then.getTime()
  }
  return `${Math.round(milliseconds)}ms`
}

export const kbSize = value => {
  return `${(value / 1024).toFixed(1)} kB`
}

export const addPositioningCssToHtmlElementIfMissing = element => {
  const elementCurrentPositionStyle = getComputedStyle(element).position
  if (['static', 'unset'].indexOf(elementCurrentPositionStyle) > -1) {
    element.style.position = 'relative'
  }
}

export const stickyPositionStringToPositioningCSS = (
  stickyPosition,
  offsets,
  position,
  callerThis
) => {
  if (!position) {
    position = 'absolute'
  }
  let cssString = ''
  if (!offsets) {
    offsets = {
      n: 0,
      s: 0,
      e: 0,
      w: 0
    }
  }
  //
  //  Setup our config and apply it if matching value is present in stickyPosition.
  const config = {
    n: `top: ${offsets.n}; `,
    s: `bottom: ${offsets.s}; `,
    e: `right: ${offsets.e}; `,
    w: `left: ${offsets.w}; `
  }
  for (const [key, value] of Object.entries(config)) {
    if (stickyPosition.toLowerCase().indexOf(key) > -1) {
      cssString += value
    }
  }
  //
  //  Set a default of 42 which is close enough to center on both axis as our button is square.
  //  Caution: If our parentElement changes size, we will need to re-run this function.
  let centeringOffsetPercentage = 42
  try {
    //
    //  When centering against a mid-point we need to calculate our height etc.
    //  Read our own width from the caller's this.
    const ourWidth = callerThis.getBoundingClientRect().width
    //
    //  Get the width of the parent.
    const parentWidth = callerThis.parentNode.getBoundingClientRect().width
    //
    //  Ok, calculate the remaning space.
    const availableSpace = parentWidth - ourWidth
    const availableSpacePercentage = (availableSpace / parentWidth) * 100
    //
    //  Apply this via a fixed percentage.
    centeringOffsetPercentage = availableSpacePercentage / 2
  } catch (err) {
    //
    //  Skipped for now.
  }
  //
  //  Apply our centering offset when we are marked for addition to an axis center point.
  if (
    stickyPosition.toLowerCase() === 'e' ||
    stickyPosition.toLowerCase() === 'w'
  ) {
    if (position === 'fixed') {
      cssString += `top: ${centeringOffsetPercentage}vh;`
    } else {
      cssString += `top: ${centeringOffsetPercentage}%;`
    }
  }
  if (
    stickyPosition.toLowerCase() === 'n' ||
    stickyPosition.toLowerCase() === 's'
  ) {
    if (position === 'fixed') {
      cssString += `left: ${centeringOffsetPercentage}vw;`
    } else {
      cssString += `left: ${centeringOffsetPercentage}%;`
    }
  }
  //
  //  Assemble and return the final css string.
  cssString = `position: ${position}; ${cssString}`
  return cssString
}

export const readPaddingOffsetsFromElement = element => {
  const styles = getComputedStyle(element)
  return {
    n: styles.paddingTop,
    s: styles.paddingBottom,
    w: styles.paddingRight,
    e: styles.paddingLeft
  }
}

export const selectRandomElementFromArray = data => {
  return data[Math.floor(Math.random() * data.length)]
}

export const flattenObj = (obj, parent, res = {}) => {
  for (let key in obj) {
    let propName = parent ? parent + '_' + key : key
    if (typeof obj[key] == 'object') {
      flattenObj(obj[key], propName, res)
    } else {
      res[propName] = obj[key]
    }
  }
  return res
}

export const safeToBase64 = value => {
  if (!value) {
    return null
  }
  return btoa(
    encodeURIComponent(value).replace(
      /%([0-9A-F]{2})/g,
      function toSolidBytes (match, p1) {
        return String.fromCharCode('0x' + p1)
      }
    )
  )
}

export const safeFromBase64 = value => {
  if (!value) {
    return null
  }
  return decodeURIComponent(
    atob(value)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
}
